import type { MapSettingsPlacesResponse } from '~/map/map.repository';
import { PlacesSearchProvider } from '~/places/places.repository';
import { mapSettingsPlacesInitialState } from './mapSettingsPlaces.reducer';
import type { MapSettingsPlacesState } from './mapSettingsPlaces.state';

export const mapSettingsPlacesSerializer = {
  jsonToState: (json: MapSettingsPlacesResponse): MapSettingsPlacesState => {
    const { searches, ...rest } = json;

    return {
      ...mapSettingsPlacesInitialState,
      ...rest,
      searches: (searches ?? mapSettingsPlacesInitialState.searches).map(search => ({
        ...search,
        // searches saved before the Foursquare provider was introduced were always Google ones
        provider: search.provider ?? PlacesSearchProvider.Google,
      })),
    };
  },
  stateToJson: (state: MapSettingsPlacesState): MapSettingsPlacesResponse => {
    return state;
  },
};
